import { Icon } from '../types/icons';

export const apparelIcons: Icon[] = [
	{ key: 'sweater', url: 'https://cdn.easysize.me/icons/sweater-apparel.svg' },
	{ key: 'dress', url: 'https://cdn.easysize.me/icons/dress-apparel.svg' },
	{ key: 'tshirt', url: 'https://cdn.easysize.me/icons/t-shirts-apparel.svg' },
	{ key: 'shirts', url: 'https://cdn.easysize.me/icons/shirts-apparel.svg' },
]